import remoteApi from "utils/remoteApi";

export const onGetLocations = (): Promise<{ locations: Array<Coordinates> }> => remoteApi.get("/locations");
